import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icons from '@components/Icons';
import { Paragraph } from '../Styled';
import { AlertWrapper, InfoWrapper } from './Alert.style';
const alertTypes = {
    INFO: {
        icon: _jsx(Icons.InformationCircle, {})
    },
    WARNING: {
        icon: _jsx(Icons.ExclamationTriangle, {})
    }
};
const Alert = (props) => {
    const { alertType = 'INFO', message, children } = props;
    return (_jsxs(AlertWrapper, { alertType: alertType, children: [_jsxs(InfoWrapper, { children: [alertTypes[alertType].icon, _jsx(Paragraph, { children: message })] }), children] }));
};
Alert.defaultProps = {
    alertType: 'INFO',
    children: undefined
};
export default Alert;
